var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetsupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#1f1f1f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "abb_help-circle-2_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Box"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 32,
    height: 32
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Final_icons_-_Common",
    "data-name": "Final icons - Common"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16,2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Zm0,26A12,12,0,1,1,28,16,12,12,0,0,1,16,28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.5,6.5a5.77,5.77,0,0,0-6,5.5v1h3V12a2.79,2.79,0,0,1,3-2.5,2.79,2.79,0,0,1,3,2.5,2.35,2.35,0,0,1-1.39,2.11,7.29,7.29,0,0,1-.76.29c-.82.28-2.35.81-2.35,2.6v3h3V17.35l.32-.11a11.23,11.23,0,0,0,1.07-.42A5.32,5.32,0,0,0,21.5,12,5.77,5.77,0,0,0,15.5,6.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 14,
    y: 22,
    width: 3,
    height: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetsupport);
export default __webpack_public_path__ + "static/media/getsupport.78f6ce45cc827924617461db1f8af8e4.svg";
export { ForwardRef as ReactComponent };